<a *ngIf="path" [routerLink]="path" routerLinkActive="active-icon">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<a *ngIf="href" [href]="href" [target]="target">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<ng-template #content>
  <app-icon
    [ngClass]="{
      'is-subsection': subsection,
      'text-16': subsection,
      'text-24': !subsection
    }"
    class="sidebar-icon"
    [name]="icon"></app-icon>
  <app-text
    class="sidebar-text"
    [text]="text"
    [class.text-18]="!subsection"
    [class.text-14]="subsection"
  ></app-text>
</ng-template>
